import ApplicationSerializer from 'frontend-payments/serializers/application';

export default class AccountSerializer extends ApplicationSerializer {
  primaryKey = 'account_number';
}
